import { Link } from 'react-router-dom';
import { CHANNEL_LABEL, type AiMilestoneDto } from '@coachrex/shared';
import { useRemoveAiMilestone } from '../lib/api';
import { relativeStamp } from '../lib/format';
import { ErrorBox } from './ui';
import { useToast } from './Toast';

/** "The AI hears it" milestones the AI counted, with what it heard. Remove un-reaches one the AI got wrong. */
export function AiHeardList({ items, timeZone, showLead }: { items: AiMilestoneDto[]; timeZone: string; showLead?: boolean }) {
  const remove = useRemoveAiMilestone();
  const toast = useToast();
  if (!items.length) return null;
  return (
    <div className="suggestions">
      {remove.error && <ErrorBox error={remove.error} />}
      {items.map((s) => (
        <div key={s.id} className="suggestion">
          <span className="suggestion__head">
            <span className="suggestion__badge">AI heard</span>
            <b>{s.milestone}</b>
            {showLead && (
              <span className="card-meta">
                · <Link to={`/conversations/${s.leadId}`}>{s.leadName}</Link>
              </span>
            )}
          </span>
          <span className="suggestion__evidence">{s.evidence}</span>
          <span className="card-meta">
            {s.channel ? `${CHANNEL_LABEL[s.channel]} · ` : ''}
            {relativeStamp(s.at, timeZone)}
          </span>
          <span className="suggestion__actions">
            <button
              className="btn btn--secondary btn--sm"
              disabled={remove.isPending}
              onClick={() =>
                remove.mutate(s.id, { onSuccess: () => toast({ text: `Removed “${s.milestone}” for ${showLead ? s.leadName : 'this lead'}. The AI won’t add it again.` }) })
              }
            >
              Not right? Remove
            </button>
          </span>
        </div>
      ))}
    </div>
  );
}
